import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  Button,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneMuseum } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiClock,
  FiSun,
  FiRepeat,
  FiDollarSign,
  FiPlus,
} from "react-icons/fi";
import { FaLandmark } from "react-icons/fa";

const REPEAT_OPTIONS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const museum: any = getOneMuseum();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const museum_id = museum?.museum_id;
  const [thumbnail, setThumbnail] = useState<any>(museum?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(museum?.image_cdn_id);
  const [title, setTitle] = useState<any>(museum?.title);
  const [venue, setVenue] = useState<any>(museum?.venue);
  const [venueCapacity, setVenueCapacity] = useState<any>(
    museum?.venue_capacity
  );
  const [startDate, setStartDate] = useState<any>(museum?.start_date);
  const [endDate, setEndDate] = useState<any>(museum?.end_date);
  const [startTime, setStartTime] = useState<any>(museum?.start_time);
  const [endTime, setEndTime] = useState<any>(museum?.end_time);
  const [email, setEmail] = useState<any>(museum?.email_address);
  const [payLink, setPayLink] = useState<any>(museum?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(museum?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(museum?.whatsapp);
  const [facebook, setFacebook] = useState<any>(museum?.facebook);
  const [twitter, setTwitter] = useState<any>(museum?.twitter);
  const [instagram, setInstagram] = useState<any>(museum?.instagram);
  const [youtube, setYoutube] = useState<any>(museum?.youtube);
  const [hashtags, setHashtags] = useState<any>(museum?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    museum?.google_map_code
  );
  const [latitude, setLatitude] = useState<any>(museum?.latitude);
  const [longitude, setLongitude] = useState<any>(museum?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    museum?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(museum?.featured);
  const [promoted, setPromoted] = useState<any>(
    museum?.promoted ? museum?.promoted : "no"
  );
  const [museumStatus, setMuseumStatus] = useState<any>(museum?.status);
  const [description, setDescription] = useState<any>(museum?.description);
  const [repeatEvery, setRepeatEvery] = useState<any>(museum?.repeat_every);
  const [expo, setExpo] = useState<any>(museum?.expo);

  const [bestTime, setBestTime] = useState<any>(
    museum?.best_time_to_visit ? museum?.best_time_to_visit : []
  );
  const [pricing, setPricing] = useState<any>(museum?.Pricings);

  const [showModal, setShowModal] = useState(false);
  const [collection, setCollection] = useState<any>(
    museum?.WhatIsArounds ? museum?.WhatIsArounds : []
  );
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const museumRoutes = "/data/museum";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneMuseumHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : museum?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: museumStatus,
      featured: featured,
      promoted: promoted,
      repeat_every: repeatEvery,
      expo: expo,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
      subdata: collection?.length > 0 ? collection : [],
    };

    const { message, status } = await updateOneContent({
      data_id: museum_id,
      data: data,
      content: _TYPES_.MUSEUM,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const toggleRepeat = (val: string) => {
    if (repeatEvery?.toString().split("|").includes(val)) {
      let rep = "";
      repeatEvery
        ?.split("|")
        .filter((day: string) => val !== day)
        .map((weekday: string) => (rep += `${weekday}|`));
      setRepeatEvery(rep);
    } else {
      let rep = "";
      if (repeatEvery) {
        [...repeatEvery.split("|"), val].map(
          (weekday: string) => (rep += `${weekday}|`)
        );
        setRepeatEvery(rep);
      } else {
        setRepeatEvery(val);
      }
    }
  };

  return (
    <AddPageShell
      backRoute={museumRoutes}
      eyebrow="DoSee Data • Museums"
      title="Edit Museum"
      subtitle={`Update a museum or cultural institution in ${entry_label || "this destination"}.`}
      icon={<FaLandmark className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneMuseumHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Building, exhibit or collection photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.MUSEUMS)}
        />
      </AddSection>

      <AddSection
        title="Best Time To Visit"
        hint="Months that work best for travellers."
        icon={<FiSun className="h-4 w-4" />}
      >
        <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
      </AddSection>

      <AddSection title="Museum Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Operating schedule."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Repeat Schedule"
        hint="Optional — pick days the museum is open."
        icon={<FiRepeat className="h-4 w-4" />}
      >
        <div className="flex flex-wrap gap-2">
          {REPEAT_OPTIONS.map((val) => {
            const on = repeatEvery?.toString().split("|").includes(val);
            return (
              <span
                key={val}
                role="button"
                tabIndex={0}
                onClick={() => toggleRepeat(val)}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") && toggleRepeat(val)
                }
                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs cursor-pointer transition-colors capitalize ${
                  on
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                {on ? (
                  <MdCheckBox className="text-base" />
                ) : (
                  <MdCheckBoxOutlineBlank className="text-base" />
                )}
                {val}
              </span>
            );
          })}
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="museum_status"
        setStatus={setMuseumStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={museumStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Additional Details"
        hint="Optional sub-collections like exhibits or galleries."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <Button
          props={{
            type: "button",
            title: "Change More Details",
            category: "default",
            action: "edit",
            onClick: () => setShowModal(true),
          }}
        />
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
